import React from 'react'
import {BrowserRouter as Router} from 'react-router-dom'
import {Box, CssBaseline} from '@material-ui/core'
import {MuiThemeProvider} from '@material-ui/core/styles'
import {connect} from 'react-redux'
import Snackbar from './Snackbar'
import CacheBuster from './CacheBuster'

// global theme
import muiTheme from '../muiTheme'

// route
import Routes from './Routes'

require('typeface-montserrat')
require('dotenv').config()

const App = props => {
    const {alert} = props

    return (
        <CacheBuster>
            {({loading, isLatestVersion, refreshCacheAndReload}) => {
                if (loading) return null
                if (!loading && !isLatestVersion) {
                    refreshCacheAndReload()
                }

                return (
                    <Router>
                        <Box
                            height="100%"
                            justifyContent="flex-start"
                            style={{
                                backgroundColor:
                                    muiTheme.palette.background.default,
                            }}
                        >
                            <CssBaseline />
                            <MuiThemeProvider theme={muiTheme}>
                                {alert.message && (
                                    <Snackbar
                                        message={alert.message}
                                        variant={alert.type}
                                        aria-labelledby={alert.message}
                                    />
                                )}
                                <Routes {...props} />
                            </MuiThemeProvider>
                        </Box>
                    </Router>
                )
            }}
        </CacheBuster>
    )
}

function mapStateToProps(state) {
    const {alert, authentication} = state
    return {
        alert,
        authentication,
    }
}

export default connect(mapStateToProps)(App)
